import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "../lib/api";
import { toast } from "sonner";

const CartContext = createContext(null);
const CART_KEY = "jt_cart_id";

export function CartProvider({ children }) {
  const [cart, setCart] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const id = localStorage.getItem(CART_KEY);
    if (id) {
      api
        .post("/shop/cart/get", { cart_id: id })
        .then((r) => {
          if (r.data && r.data.id) setCart(r.data);
          else localStorage.removeItem(CART_KEY);
        })
        .catch(() => localStorage.removeItem(CART_KEY));
    }
  }, []);

  const addItem = useCallback(async (variantId, qty = 1) => {
    setLoading(true);
    const id = localStorage.getItem(CART_KEY);
    try {
      let res;
      if (id) {
        try {
          res = await api.post("/shop/cart/add", { cart_id: id, variant_id: variantId, quantity: qty });
        } catch {
          localStorage.removeItem(CART_KEY);
          res = await api.post("/shop/cart", { variant_id: variantId, quantity: qty });
        }
      } else {
        res = await api.post("/shop/cart", { variant_id: variantId, quantity: qty });
      }
      if (res.data && res.data.id) {
        localStorage.setItem(CART_KEY, res.data.id);
        setCart(res.data);
        setOpen(true);
        toast.success("Added to bag");
      }
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not add to bag");
    } finally {
      setLoading(false);
    }
  }, []);

  const updateLine = async (lineId, qty) => {
    const id = localStorage.getItem(CART_KEY);
    if (!id) return;
    setLoading(true);
    try {
      const res = await api.post("/shop/cart/update", { cart_id: id, line_id: lineId, quantity: qty });
      setCart(res.data);
    } catch {
      toast.error("Could not update bag");
    } finally {
      setLoading(false);
    }
  };

  const count = cart?.total_quantity || 0;

  return (
    <CartContext.Provider value={{ cart, open, setOpen, addItem, updateLine, loading, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
